import { checkPropTypes } from "prop-types";
import { macroCondition, isDevelopingApp } from "@embroider/macros";

export function arg(targetOrValidator, key, descriptor) {
  if (key !== undefined) {
    return createGetter(targetOrValidator, key, descriptor, undefined);
  }
  const validator = targetOrValidator;
  return (target, k, desc) => createGetter(target, k, desc, validator);
}

function createGetter(target, key, descriptor, validator) {
  const initializer = descriptor?.initializer || (() => undefined);
  return {
    get() {
      const raw = this.args[key];
      const value = raw !== undefined ? raw : initializer.call(this);
      if (macroCondition(isDevelopingApp())) {
        if (validator) {
          checkPropTypes({ [key]: validator }, { [key]: value }, "prop", this.constructor.name);
        }
      }
      return value;
    },
  };
}

export function forbidExtraArgs(target) {
  return target;
}
